import { useConfirmLeave } from '../hooks/useConfirmLeave'

export function ConfirmLeave() {
  useConfirmLeave()
  return <></>
}
